import {
  SESSION_CURRENT_USER_SET, SESSION_SET_ACCESS_TOKEN, SESSION_DESTROY,
  SESSION_REFRESH_ACCESS_TOKEN, SESSION_REFRESH_ACCESS_TOKEN_DONE,
} from '../actions/session';

const ACTION_HANDLERS = {
  [SESSION_CURRENT_USER_SET]: (state, action) => ({ ...state, user: action.payload }),
  [SESSION_SET_ACCESS_TOKEN]: (state, action) => ({ ...state, accessToken: action.payload }),
  [SESSION_DESTROY]: (state) => ({ ...state, accessToken: null }),
  [SESSION_REFRESH_ACCESS_TOKEN]: (state, action) => ({ ...state, refreshTokenPromise: action.payload }),
  [SESSION_REFRESH_ACCESS_TOKEN_DONE]: (state) => ({ ...state, refreshTokenPromise: undefined }),
};

const initialState = {
  accessToken: null
};

const sessionReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
};

export default sessionReducer;

